import {createSlice} from '@reduxjs/toolkit';
import History from '@episerver/spa-core/Routing/History';

const routingSlice = createSlice({
  name: 'routing',
  initialState: {},
  reducers: {
    pushPath: {
      reducer(state, action) {
        return state;
      },
      prepare(pathId, noHistory = false) {
        let hash;
        if (!pathId && window?.location?.hash) {
          const hashRegex = /#(.*)(\d+)$/;
          const match = hashRegex.exec(window.location.hash);
          hash = match != null ? match[1] + (match[2] * 1 + 1) : window.location.hash.substring(1) + 1;
        } else if (!pathId) hash = 'step1';
        else hash = pathId;
        if (pathId != window.location.hash.substring(1)) {
          if (noHistory) {
            History.replacePath(`#${hash}`);
          } else {
            History.pushPath(`#${hash}`);
          }
        }
        return {payload: {hash}};
      },
    },
  },
});

export const {pushPath} = routingSlice.actions;
export default routingSlice.reducer;
